import React from 'react';

export default function ConstructorDetailTable({ constructor }) {
  const keys = Object.keys(constructor.constructorData);
  const transformKeyToHeading = string => {
    const CapStr = string.charAt(0).toUpperCase() + string.slice(1);
    return CapStr.replace('_', '');
  };
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          {keys.map(key => (
            <th key={key}>{transformKeyToHeading(key)}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {keys.map(key => {
            const data = constructor.constructorData[key];
            let text = '';
            console.log('Data\n', key, ' : ', data);
            if (Array.isArray(data)) {
              text = data.length > 1 ? data.join() : data[0] || '-';
            } else {
              text = data || '-';
            }
            return <td key={key + 'Obj'}>{text}</td>;
          })}
        </tr>
      </tbody>
    </table>
  );
}
